/* global ContractGroupTeams */

window.ContractGroupTeams = {}

ContractGroupTeams.init = function () {
  $('.teams-select').on('change', function () {
    const selectedValues = $(this).find('option:selected').toArray().map(item => item.value)
    const selectForChange = (this.id === 'contract_group_team_ids_write') ? 'read_only' : 'write'
    const options = $(this).closest('.contract-group-teams')
      .find(`#contract_group_team_ids_${selectForChange}`)[0].options

    if (selectedValues) {
      hideSelectedOptionsTeams(options, selectedValues)
    }
  })

  $('.contract-group-teams select').trigger('change')

  $('.contract-group-teams-dropdown .dropdown-menu').click(function (evt) {
    evt.stopPropagation()
  })
}

function hideSelectedOptionsTeams (options, selected) {
  $(options).each(function (i, option) {
    $(option).removeClass('hidden')

    if (selected.includes(option.value)) {
      $(option).addClass('hidden')
    }
  })
}
